import { getVendorTaxonomyId } from '@zola-helpers/client/dist/es/marketplace/vendorUtils';
import type {
  VendorMarketSupplyRequest,
  VendorMarketSupplyView,
} from '@zola/svc-marketplace-ts-types';

import type { VendorSearchRequest } from '~/pages/couples/explore/components/SearchResults/types/types';
import { buildSearchRequest } from '~/pages/couples/explore/util/buildSearchRequest';
import type { ClientApiServiceType } from '~/util/apiService';
import { isSearchLocation } from '~/util/searchUtils';

import type { ServerApiServiceType } from '../server/util/apiService';

export const getSearchLocationForSlug = (
  locationSlug: string,
  apiService: ServerApiServiceType | ClientApiServiceType
) => {
  return apiService
    .get(`/web-marketplace-api/v1/search-location/slug/${encodeURIComponent(locationSlug)}`)
    .then((response) => {
      if (isSearchLocation(response)) {
        return response;
      }
      return null;
    })
    .catch(() => null);
};

const getDetermineMarketSupplyParams = (
  request: VendorSearchRequest
): VendorMarketSupplyRequest | undefined => {
  const { selectedLocation, selectedTaxonomy } = request;
  const vendorMarketId = selectedLocation?.storefrontSearchPayload?.vendorMarketId || undefined;
  const taxonomyNodeId = getVendorTaxonomyId(selectedTaxonomy?.key);
  // we can only determine supply for vendor type / market combinations
  if (vendorMarketId && taxonomyNodeId) {
    return {
      vendorMarketId,
      taxonomyNodeId,
      flexibleOnLocation:
        buildSearchRequest(request, 100, false).locationMethod === 'ADJACENT_MARKET',
    };
  }
  return undefined;
};

export const determineMarketSupplyForVendorSearch = async (
  request: VendorSearchRequest,
  apiService: ServerApiServiceType | ClientApiServiceType
) => {
  const params = getDetermineMarketSupplyParams(request);
  if (params) {
    return fetchMarketSupply(params, apiService).then(({ supplied }) => {
      return supplied === false ? supplied : true;
    });
  }
  return Promise.resolve(true);
};

export const fetchMarketSupply = async (
  request: VendorMarketSupplyRequest,
  apiService: ServerApiServiceType | ClientApiServiceType
) => {
  return apiService.post<VendorMarketSupplyView, VendorMarketSupplyRequest>(
    '/web-marketplace-api/v2/vendor-market/supply',
    request
  );
};
